// Single source of truth for membership tier badges (previously duplicated in
// Navbar.js and TopTabs.js). Icons are Material Symbols names (see ui/Icon.js).
import { colors } from './tokens';

const TIERS = {
  silver:   { icon: 'workspace_premium', color: colors.silver,   label: 'Silver' },
  gold:     { icon: 'military_tech',     color: colors.gold,     label: 'Gold' },
  platinum: { icon: 'diamond',           color: colors.platinum, label: 'Platinum' },
  rubber:   { icon: 'do_not_disturb_on', color: colors.rubber,   label: 'Rubber' }
};

export function getTierBadge(tier) {
  return TIERS[tier] || TIERS.silver;
}

export const SALES_ROLE = {
  manager: { icon: 'badge', label: 'Manager', short: 'Mgr', color: colors.ink },
  rep:     { icon: 'support_agent', label: 'Rep', short: 'Rep', color: colors.parLime }
};

export function getSalesRole(role) {
  return SALES_ROLE[role] || null;
}
